import PropTypes from 'prop-types'
import classNames from 'classnames'
import { useDispatch } from 'react-redux'
import { Link } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import ReactTooltip from 'react-tooltip'

import { signOutUser } from '../../actions/authActions'

import classes from './UserMenuTooltip.module.scss'

const UserMenuTooltip = ({ id, user, showProfile = true, showDashboard = true }) => {
  const { t } = useTranslation()
  const dispatch = useDispatch()

  const handleLogout = (e) => {
    e.preventDefault()
    dispatch(signOutUser())
  }

  return (
    <ReactTooltip
      id={id}
      offset={{ top: '4', left: '2' }}
      effect='solid'
      place='bottom'
      delayUpdate={100}
      delayHide={100}
      className={classes.tooltipWrapper}
    >
      <div className={classNames(classes.userTooltip, 'd-flex flex-column p-0')}>
        {showProfile && user.type !== 'Admin' && <Link to={`/profile/${user.id}`}>{t('common.action.viewProfile')}</Link>}
        {showDashboard && <Link to='/dashboard'>{t('common.landingHeader.dashboard')}</Link>}
        <button onClick={handleLogout} className={classes.logOut}>{t('common.logOut')}</button>
      </div>
    </ReactTooltip>
  )
}

UserMenuTooltip.propTypes = {
  id: PropTypes.string.isRequired,
  user: PropTypes.shape({ id: PropTypes.number.isRequired, type: PropTypes.string }).isRequired,
  showProfile: PropTypes.bool,
  showDashboard: PropTypes.bool,
}

export default UserMenuTooltip
